import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const pagesDataServices: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/pages-data-services`),
};

export default pagesDataServices;
